/**
 * @flow
 * @relayHash 18d60eafad335d08952398df4a1d6541
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RequestLoginWhenExpiredInput = {|
  language?: ?string,
  token: string,
|};
export type RequestLoginWhenExpiredMutationVariables = {|
  input: RequestLoginWhenExpiredInput
|};
export type RequestLoginWhenExpiredMutationResponse = {|
  +requestLoginWhenExpired: ?{|
    +status: ?string
  |}
|};
export type RequestLoginWhenExpiredMutation = {|
  variables: RequestLoginWhenExpiredMutationVariables,
  response: RequestLoginWhenExpiredMutationResponse,
|};
*/


/*
mutation RequestLoginWhenExpiredMutation(
  $input: RequestLoginWhenExpiredInput!
) {
  requestLoginWhenExpired(input: $input) {
    status
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RequestLoginWhenExpiredInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "requestLoginWhenExpired",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestLoginWhenExpiredPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RequestLoginWhenExpiredMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RequestLoginWhenExpiredMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "RequestLoginWhenExpiredMutation",
    "id": null,
    "text": "mutation RequestLoginWhenExpiredMutation(\n  $input: RequestLoginWhenExpiredInput!\n) {\n  requestLoginWhenExpired(input: $input) {\n    status\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b09da912bafcb0ec1e5e086371269f22';

module.exports = node;
